function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { roomTagsGET, roomAvatarPOST, roomBannerPOST, roomAvatarDELETE, roomBannerDELETE, roomDELETE, roomGET, roomModeratorPOST, roomPOST, roomPUT, roomServerPOST, roomSessionDELETE, roomSessionGET, roomSessionPOST, roomSessionPUT, roomSessionsGET, roomSettingsPOST, roomsGET, roomThumbnailPOST, roomsSessionsGET, roomThumbnailDELETE, roomMembersGET, roomMemberPUT, roomMemberDELETE, roomSlugGET, roomSessionThumbnailPOST, roomSessionThumbnailDELETE, roomCapturerGET, studioUnpinPOST } from "@internal/api/room";
import { useInfiniteQuery, useMutation, useQuery } from "react-query";
import { QueryKey } from "./queryKeys";
import { useApiContext } from "./context";
import { useUpdateableQuery } from "./utils";
import { useMutationSuccessHandler } from "./utils";
export var useRoom = function(request, options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    return useQuery([
        QueryKey.Room,
        request,
        token
    ], function() {
        return roomGET(token, request, host);
    }, options);
};
export var useInfiniteRoomMembers = function(request, options) {
    var host = useApiContext().host;
    return useInfiniteQuery([
        QueryKey.RoomMembers,
        request
    ], function(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
        return roomMembersGET(_objectSpread({
            page: pageParam
        }, request), host);
    }, _objectSpread({}, options, {
        getPreviousPageParam: function() {
            return undefined;
        },
        getNextPageParam: function(lastPage, pages) {
            return lastPage.length < request.pageSize ? undefined : pages.length + 1;
        }
    }));
};
export var useRoomMembers = function(request, options) {
    var host = useApiContext().host;
    return useQuery([
        QueryKey.RoomMembers,
        request
    ], function() {
        return roomMembersGET(request, host);
    }, options);
};
export var useRoomMemberCreateMutation = function(options) {
    var ref = useApiContext(), token = ref.token, host = ref.host;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room,
        QueryKey.Rooms,
        QueryKey.RoomMembers, 
    ]);
    return useMutation(function(request) {
        return roomMemberPUT(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomMemberDeleteMutation = function(options) {
    var ref = useApiContext(), token = ref.token, host = ref.host;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room,
        QueryKey.Rooms,
        QueryKey.RoomMembers, 
    ]);
    return useMutation(function(request) {
        return roomMemberDELETE(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomCreateMutation = function(options) {
    var ref = useApiContext(), token = ref.token, host = ref.host;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Rooms
    ]);
    return useMutation(function(request) {
        return roomPUT(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomDeleteMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Rooms
    ]);
    return useMutation(function(request) {
        return roomDELETE(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomUpdateMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room,
        QueryKey.Rooms
    ]);
    return useMutation(function(request) {
        return roomPOST(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomAvatarMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room
    ]);
    return useMutation(function(request) {
        return roomAvatarPOST(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomBannerMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room
    ]);
    return useMutation(function(request) {
        return roomBannerPOST(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomAvatarDeleteMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room
    ]);
    return useMutation(function(request) {
        return roomAvatarDELETE(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomBannerDeleteMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room
    ]);
    return useMutation(function(request) {
        return roomBannerDELETE(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomThumbnailMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room
    ]);
    return useMutation(function(request) {
        return roomThumbnailPOST(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomThumbnailDeleteMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room
    ]);
    return useMutation(function(request) {
        return roomThumbnailDELETE(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomModeratorMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room,
        QueryKey.Rooms,
        QueryKey.RoomMembers, 
    ]);
    return useMutation(function(request) {
        return roomModeratorPOST(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomSettingsMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room,
        QueryKey.Rooms
    ]);
    return useMutation(function(request) {
        return roomSettingsPOST(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRooms = function(request, options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    return useQuery([
        QueryKey.Rooms,
        request,
        token
    ], function() {
        return roomsGET(token, request, host);
    }, options);
};
export var useRoomsSessions = function(request, options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    return useQuery([
        QueryKey.RoomsSessions,
        request,
        token
    ], function() {
        return roomsSessionsGET(token, request, host);
    }, options);
};
export var useRoomSession = function(request, options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    return useQuery([
        QueryKey.RoomSession,
        request,
        token
    ], function() {
        return roomSessionGET(token, request, host);
    }, options);
};
export var useRoomSessions = function(request, options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    return useUpdateableQuery([
        QueryKey.RoomSessions,
        request,
        token
    ], function() {
        return roomSessionsGET(token, request, host);
    }, options);
};
export var useRoomSessionCreateMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room,
        QueryKey.Rooms,
        QueryKey.RoomSessions,
        QueryKey.RoomsSessions, 
    ]);
    return useMutation(function(request) {
        return roomSessionPUT(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomSessionUpdateMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room,
        QueryKey.Rooms,
        QueryKey.RoomSessions,
        QueryKey.RoomsSessions, 
    ]);
    return useMutation(function(request) {
        return roomSessionPOST(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomSessionDeleteMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room,
        QueryKey.Rooms,
        QueryKey.RoomSessions,
        QueryKey.RoomsSessions, 
    ]);
    return useMutation(function(request) {
        return roomSessionDELETE(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomSessionThumbnailUpdate = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room,
        QueryKey.Rooms,
        QueryKey.RoomSessions,
        QueryKey.RoomsSessions, 
    ]);
    return useMutation(function(request) {
        return roomSessionThumbnailPOST(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomSessionThumbnailDelete = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    var onSuccess = useMutationSuccessHandler(options, [
        QueryKey.Room,
        QueryKey.Rooms,
        QueryKey.RoomSessions,
        QueryKey.RoomsSessions, 
    ]);
    return useMutation(function(request) {
        return roomSessionThumbnailDELETE(token, request, host);
    }, _objectSpread({}, options, {
        onSuccess: onSuccess
    }));
};
export var useRoomTags = function(request, options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    return useQuery([
        QueryKey.Tags,
        request,
        token
    ], function() {
        return roomTagsGET(token, request, host);
    }, options);
};
export var useRoomSlug = function(request, options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    return useQuery([
        QueryKey.Slug,
        request,
        token
    ], function() {
        return roomSlugGET(token, request, host);
    }, _objectSpread({
        retry: false
    }, options));
};
export var useRoomServerConnectMutation = function(mutationOptions) {
    var host = useApiContext().host;
    return useMutation(function(request) {
        return roomServerPOST(request, host);
    }, mutationOptions);
};
export var useRoomCapturer = function(request, options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    return useQuery([
        QueryKey.RoomCapturer,
        request,
        token
    ], function() {
        return roomCapturerGET(token, request, host);
    }, options);
};
export var useStudioUnpinMutation = function(options) {
    var ref = useApiContext(), host = ref.host, token = ref.token;
    return useMutation(function(request) {
        return studioUnpinPOST(token, request, host);
    }, options);
};
